<ion-content >
  <div class="container">
    <section class="user-summary-section no-flex-container">
      <div class="profile-avatar-wrapper">
        <app-avatar></app-avatar>
        <ion-icon id="ic-plus" color="primary" name="add-circle"></ion-icon>
      </div>

      <div class="user-info">
        <div>
          <h4>{{ loggedInUser?.firstName }} {{ loggedInUser?.lastName }}</h4>
          @if (loggedInUser?.username) {
            <ion-label class="username-label">
              <p class="username">{{'@' + loggedInUser?.username}}</p>
            </ion-label>
          }
          <a class="see-profile-link" (click)="goToMyProfile()" tabindex="0" (keydown.enter)="goToMyProfile()">See Profile</a>
        </div>
      </div>
      <ion-label class="activity-stats">
        <ion-text (click)="goToPage('my-charities')">
          <span class="bold">{{ following }}</span> Following
        </ion-text> • 
        <ion-text (click)="goToPage('history')">
          <span class="bold">{{ donations }}</span> Donations
        </ion-text> • 
        <ion-text (click)="goToPage('credits')">
          <span class="bold">{{ credits }}</span> Credits
        </ion-text>
      </ion-label>
    </section>

    <ion-list>

      <!-- <ion-item lines="none" [button]="true" (click)="editProfile()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Edit Profile Information</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">First Name, Last Name</ion-note>
        </ion-label>
      </ion-item> -->

      <ion-item lines="none" [button]="true" (click)="goToItem('user-info')">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Account Information</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Name, Phone Number, Address</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToItem('settings')">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Settings</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Preferences, Privacy, Security</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToItem('recurring-donations')">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Recurring Donations</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Manage Donation Subscriptions</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToPage('user-orders')">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Orders</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">See your Marketplace Orders</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToItem('manage-charity')">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Manage Charities</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Manage or claim a charity</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToItem('manage-business')">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Manage Businesses</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Manage a business account</ion-note>
        </ion-label>
      </ion-item>

      <!-- <ion-item lines="none">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Account No</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">#123232323</ion-note>
        </ion-label>
      </ion-item> -->
    </ion-list>

    @if (!authorityLoaded) {
      <div class="btn-charity">
        <button disabled>
          <ion-skeleton-text animated style="width: 120px; height: 20px;"></ion-skeleton-text>
        </button>
      </div>
    } @else {
      @if (permittedCharities && permittedCharities.length > 0) {
        <div class="btn-charity">
          <button 
            (click)="switchToCharity()" 
            [disabled]="isSwitchingToCharity"
            [class.loading]="isSwitchingToCharity">
            {{ isSwitchingToCharity ? 'Switching...' : 'Switch to Charity Portal' }}
          </button>
        </div>
      }
      @if (permittedBusinesses && permittedBusinesses.length > 0) {
        <div class="btn-charity">
          <button 
            class="business-btn"
            (click)="switchToBusiness()" 
            [disabled]="isSwitchingToBusiness"
            [class.loading]="isSwitchingToBusiness">
            {{ isSwitchingToBusiness ? 'Switching...' : 'Switch to Business Portal' }}
          </button>
        </div>
      }
      @if ((!permittedCharities || permittedCharities.length === 0) && (!permittedBusinesses || permittedBusinesses.length === 0)) {
        <div class="btn-charity">
          <button (click)="goToItem('manage-charity')">
            Claim a Charity
          </button>
        </div>
      }
    }
    <div class="btn-signout">
      <button (click)="signOut()">Log Out</button>
    </div>
    
    <div class="support-link">
      <a (click)="goToPage('support')" tabindex="0" (keydown.enter)="goToPage('support')">Frequently Asked Questions</a>
    </div>
    
    @if (shouldShowVersion) {
      <div class="version-display">
        <ion-text color="medium">
          <small>{{ appVersion }}</small>
        </ion-text>
      </div>
    }
  </div>
</ion-content>
